import dayjs from 'dayjs';
import { dateStore } from '../store/dateStore';
import { useMemo } from 'react';

export const SATELLITE_END_DATE = '2026-01-08T23:59:59';
export const IS_TAB_OPEN_DATE = '2025-12-29T09:59:59';
export const IS_OVER_PRIVACY_END_DATE = '2026-01-23T01:59:59';
export const SHOW_QR_DATE = '2026-01-09T23:59:59';

export const useDateHook = () => {
  const { today, setToday } = dateStore();

  const isOpenTabDate = () => {
    const targetDate = dayjs(IS_TAB_OPEN_DATE);

    return today.isAfter(targetDate);
  };

  // 온라인 세틀라이트 종료일
  const isSatelliteEnd = () => {
    const targetDate = dayjs(SATELLITE_END_DATE);

    return today.isAfter(targetDate);
  };

  // 개인정보 처리방침 동의 종료일
  const isOverPrivacyDate = useMemo(() => {
    const targetDate = dayjs(IS_OVER_PRIVACY_END_DATE);

    return today.isAfter(targetDate);
  }, [today]);

  // QR코드 노출일
  const showQrDate = () => {
    const targetDate = dayjs(SHOW_QR_DATE);

    return today.isAfter(targetDate);
  };

  const setTodayDate = () => {
    setToday(dayjs());
  };

  return {
    setTodayDate,
    isOpenTabDate,
    isOverPrivacyDate,
    today,
    isSatelliteEnd,
    showQrDate,
    setToday,
  };
};
